import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref } from "vue";
const _hoisted_1 = {
    class: "collapse-tags-tooltip"
};
const _hoisted_2 = {
    class: "flex flex-wrap gap-2 max-w-xs"
};
import { ref, watch, onMounted, onBeforeUnmount, nextTick, computed } from 'vue';
import { useElementSize } from '@vueuse/core';
import CustomTooltip from './CustomTooltip.vue';
export default /*@__PURE__*/ _defineComponent({
    ...{
        name: 'CollapseTagsTooltip'
    },
    __name: 'CollapseTagsTooltip',
    props: {
        tags: {},
        effect: {
            default: 'light'
        },
        type: {
            default: 'primary'
        },
        maxRows: {
            default: 2
        },
        tagClass: {
            default: '!px-3px !py-1px text-12px text-white bg-blue-500 rounded'
        },
        moreButtonClass: {
            default: '!px-3px !py-1px text-12px text-blue-600 bg-blue-100 border border-blue-200 rounded cursor-pointer hover:bg-blue-200 transition-colors'
        },
        align: {
            default: 'left'
        }
    },
    setup (__props) {
        const props = __props;
        // --- 响应式状态 ---
        const containerRef = ref(null);
        const measureRef = ref(null);
        const visibleTags = ref([]);
        const hiddenTags = ref([]);
        // 使用 VueUse 的 useElementSize 获取容器宽度
        const { width: containerWidth } = useElementSize(containerRef);
        // 计算隐藏标签的数量
        const hiddenCount = computed(()=>hiddenTags.value.length);
        // --- 核心逻辑：更新标签显示 ---
        const updateTagsDisplay = async ()=>{
            if (!containerRef.value || !measureRef.value) return;
            // 等待 DOM 更新完成
            await nextTick();
            const measureContainer = measureRef.value;
            // 清空测量容器并添加所有标签进行测量
            measureContainer.innerHTML = '';
            const tagElements = [];
            props.tags.forEach((tag)=>{
                const tagElement = document.createElement('span');
                tagElement.className = `tag-item flex-shrink-0 ${props.tagClass} mr-2 mb-2`;
                tagElement.textContent = tag;
                tagElement.style.visibility = 'hidden';
                measureContainer.appendChild(tagElement);
                tagElements.push(tagElement);
            });
            // 添加更多按钮进行测量
            const moreButton = document.createElement('button');
            moreButton.className = `more-button flex-shrink-0 ${props.moreButtonClass} mr-2 mb-2`;
            moreButton.textContent = '+99'; // 使用最大可能的数字进行测量
            moreButton.style.visibility = 'hidden';
            measureContainer.appendChild(moreButton);
            await nextTick();
            if (!tagElements.length) {
                visibleTags.value = [];
                hiddenTags.value = [];
                return;
            }
            // 计算每行的标签
            const rows = [];
            let currentRow = [];
            let currentRowTop = -1;
            tagElements.forEach((element, index)=>{
                if (currentRowTop === -1) {
                    currentRowTop = element.offsetTop;
                }
                if (element.offsetTop > currentRowTop) {
                    if (currentRow.length > 0) {
                        rows.push([
                            ...currentRow
                        ]);
                    }
                    currentRow = [
                        index
                    ];
                    currentRowTop = element.offsetTop;
                } else {
                    currentRow.push(index);
                }
            });
            if (currentRow.length > 0) {
                rows.push(currentRow);
            }
            // 如果行数小于等于最大行数，显示所有标签
            if (rows.length <= props.maxRows) {
                visibleTags.value = [
                    ...props.tags
                ];
                hiddenTags.value = [];
                return;
            }
            // 计算需要显示的标签（前maxRows行）
            const visibleIndices = [];
            for(let i = 0; i < Math.min(props.maxRows, rows.length); i++){
                if (rows[i]) {
                    visibleIndices.push(...rows[i]);
                }
            }
            // 检查最后一行是否有足够空间放置更多按钮
            if (props.maxRows > 0 && rows.length > props.maxRows) {
                const lastRowIndices = rows[props.maxRows - 1] || [];
                if (lastRowIndices.length > 0) {
                    const lastTagInRow = tagElements[lastRowIndices[lastRowIndices.length - 1]];
                    const moreButtonWidth = moreButton.offsetWidth;
                    const availableWidth = containerWidth.value - (lastTagInRow.offsetLeft + lastTagInRow.offsetWidth + 8);
                    if (availableWidth < moreButtonWidth) {
                        visibleIndices.pop();
                    }
                }
            }
            // 设置可见和隐藏的标签
            visibleTags.value = visibleIndices.map((index)=>props.tags[index]);
            hiddenTags.value = props.tags.filter((_, index)=>!visibleIndices.includes(index));
        };
        // --- ResizeObserver ---
        let resizeObserver = null;
        onMounted(()=>{
            if (containerRef.value) {
                resizeObserver = new ResizeObserver(()=>{
                    nextTick(updateTagsDisplay);
                });
                resizeObserver.observe(containerRef.value);
            }
            // 初始加载时计算
            nextTick(updateTagsDisplay);
        });
        // 组件卸载前，清理 Observer
        onBeforeUnmount(()=>{
            if (resizeObserver && containerRef.value) {
                resizeObserver.unobserve(containerRef.value);
                resizeObserver.disconnect();
            }
        });
        // 当传入的 tags 数组变化时，重新计算
        watch(()=>props.tags, ()=>{
            nextTick(updateTagsDisplay);
        }, {
            deep: true
        });
        // 当最大行数变化时，重新计算
        watch(()=>props.maxRows, ()=>{
            nextTick(updateTagsDisplay);
        });
        // 当容器宽度变化时，重新计算
        watch(()=>containerWidth.value, ()=>{
            nextTick(updateTagsDisplay);
        });
        return (_ctx, _cache)=>{
            const _component_ElTag = _resolveComponent("ElTag");
            return _openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    ref_key: "containerRef",
                    ref: containerRef,
                    class: _normalizeClass([
                        "flex items-center flex-wrap w-full gap-2",
                        [
                            props.align === 'center' ? 'justify-center' : props.align === 'right' ? 'justify-end' : 'justify-start'
                        ]
                    ])
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleTags.value, (tag)=>{
                        return _openBlock(), _createBlock(_component_ElTag, {
                            key: tag,
                            class: _normalizeClass([
                                [
                                    props.tagClass
                                ],
                                "flex-shrink-0"
                            ]),
                            effect: props.effect,
                            type: props.type
                        }, {
                            default: _withCtx(()=>[
                                    _createTextVNode(_toDisplayString(tag), 1)
                                ]),
                            _: 2
                        }, 1032, [
                            "class",
                            "effect",
                            "type"
                        ]);
                    }), 128)),
                    visibleTags.value.length === 0 ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "text-gray-500 w-full",
                        style: _normalizeStyle({
                            textAlign: props.align
                        })
                    }, "-", 4)) : _createCommentVNode("", true),
                    hiddenCount.value > 0 ? (_openBlock(), _createBlock(CustomTooltip, {
                        key: 1,
                        placement: "top",
                        "show-after": 200,
                        "hide-after": 100,
                        "popper-class": "collapse-tags-tooltip-popper"
                    }, {
                        default: _withCtx(()=>[
                                _createVNode(_component_ElTag, {
                                    class: _normalizeClass([
                                        [
                                            props.moreButtonClass
                                        ],
                                        "flex-shrink-0"
                                    ]),
                                    effect: props.effect,
                                    type: props.type
                                }, {
                                    default: _withCtx(()=>[
                                            _createTextVNode(" +" + _toDisplayString(hiddenCount.value), 1)
                                        ]),
                                    _: 1
                                }, 8, [
                                    "class",
                                    "effect",
                                    "type"
                                ])
                            ]),
                        content: _withCtx(()=>[
                                _createElementVNode("div", _hoisted_2, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hiddenTags.value, (tag)=>{
                                        return _openBlock(), _createBlock(_component_ElTag, {
                                            key: tag,
                                            class: _normalizeClass([
                                                [
                                                    props.tagClass
                                                ],
                                                "flex-shrink-0"
                                            ]),
                                            effect: props.effect,
                                            type: props.type
                                        }, {
                                            default: _withCtx(()=>[
                                                    _createTextVNode(_toDisplayString(tag), 1)
                                                ]),
                                            _: 2
                                        }, 1032, [
                                            "class",
                                            "effect",
                                            "type"
                                        ]);
                                    }), 128))
                                ])
                            ]),
                        _: 1
                    })) : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                    ref_key: "measureRef",
                    ref: measureRef,
                    class: "absolute top-0 left-0 flex items-start flex-wrap gap-2 pointer-events-none opacity-0 -z-10",
                    style: _normalizeStyle({
                        width: _unref(containerWidth) + 'px'
                    })
                }, null, 4)
            ]);
        };
    }
});
